export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 3MB in bytes

export const ALLOWED_TYPE_PHOTO = ['jpg', 'jpeg', 'png', 'webp'];
